import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ProjectCard.css";

export default function ProjectCard({ 
  title, 
  subtitle, 
  image, 
  hoverColor = "#f0f0f0",
  projectKey,
  onClick 
}) {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick(projectKey);
    } else if (projectKey) {
      navigate(`/projects?project=${projectKey}`);
    }
  };

  return (
    <article 
      className="project-card"
      style={{
        backgroundColor: isHovered ? hoverColor : "transparent"
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
    >
      <div className="project-card__image-container">
        {image ? (
          <img src={image} alt={title} className="project-card__image" />
        ) : (
          <div className="project-card__image-placeholder" />
        )}
      </div>
      <div className="project-card__info">
        <h3 className="project-card__title">{title}</h3>
        <p className="project-card__subtitle">{subtitle}</p>
      </div>
    </article>
  );
}